package one.healthium.onboarding.ui.user_binding

import co.touchlab.kermit.Logger
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.retry
import one.healthium.base.preferences.AppPreferences
import one.healthium.domain.user.UserInteractor
import one.healthium.domain.user.UserModel
import one.healthium.ui.common.vm.BaseViewModel

internal class UserViewModel(
    userInteractor: UserInteractor,
    appPreferences: AppPreferences,
) : BaseViewModel() {

    private val _state = MutableStateFlow<UserUiState?>(null)
    val state = _state.asStateFlow()

    init {
        launch {
            combine(
                userInteractor.observeUser(),
                appPreferences.isMetricFlow
            ) { user, isMetric ->
                UserUiState(user, isMetric)
            }
                .catch { e ->
                    Logger.e("UserViewModel", e)
                }
                .retry()
                .collect {
                    _state.value = it
                }
        }
    }
}

data class UserUiState(
    val user: UserModel,
    val isMetric: Boolean,
)